var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.doShowConfirmationDialog
    ? _c(
        "div",
        {
          staticClass: "confirmation-popup",
          class: `${
            _vm.$route.path.startsWith("/gop/") ? "gop-modal" : "drc-modal"
          }`
        },
        [
          _c(
            "div",
            {
              staticClass: "confirmation-dialog",
              attrs: {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "center-bottom",
                "data-aos-duration": "400"
              }
            },
            [
              !_vm.hideCancel
                ? [
                    _vm.$route.path.startsWith("/gop/")
                      ? _c("img", {
                          attrs: {
                            src: require("@/common/assets/icons/x_blue.svg"),
                            alt: "close-icon"
                          },
                          on: { click: _vm.closeDialog }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/common/assets/icons/x_white.svg"),
                            alt: "close-icon"
                          },
                          on: { click: _vm.closeDialog }
                        })
                  ]
                : _vm._e(),
              _c("div", { staticClass: "confirmation-content" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.title || _vm.$t("common.areYouSure")))
                ]),
                _c("p", { staticClass: "text-container" }, [
                  _vm._v(_vm._s(_vm.text))
                ]),
                _vm.isWithCkEditor()
                  ? _c(
                      "div",
                      { staticClass: "text-field-container" },
                      [
                        _c("p", [_vm._v(_vm._s(_vm.textFiledTitle))]),
                        _c("CKEditor", {
                          key: _vm.componentKey,
                          attrs: {
                            editor: _vm.editor,
                            config: _vm.editorConfig
                          },
                          on: { input: _vm.focusOut },
                          model: {
                            value: _vm.ckEditorInputText,
                            callback: function($$v) {
                              _vm.ckEditorInputText = $$v
                            },
                            expression: "ckEditorInputText"
                          }
                        }),
                        _vm.errors.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.errors, function(error) {
                                return _c(
                                  "p",
                                  { key: error, staticClass: "errors" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t(`common.${error}`)) +
                                        " "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isRadio()
                  ? _c(
                      "div",
                      { staticClass: "radio-field-container" },
                      [
                        _vm._l(_vm.options, function(el) {
                          return [
                            _c(
                              "div",
                              {
                                key: el[_vm.displayField],
                                staticClass: "radio-button",
                                on: {
                                  click: function($event) {
                                    _vm.radioValue = el[_vm.displayField]
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.radioValue,
                                      expression: "radioValue"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    id: el[_vm.displayField]
                                  },
                                  domProps: {
                                    value: el[_vm.displayField],
                                    checked: _vm._q(
                                      _vm.radioValue,
                                      el[_vm.displayField]
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.radioValue = el[_vm.displayField]
                                    }
                                  }
                                }),
                                _c("img", {
                                  staticClass: "flag",
                                  attrs: {
                                    src: require(`@/drc/assets/images/flags/${el.short}.svg`),
                                    alt: el.name
                                  }
                                }),
                                _c(
                                  "label",
                                  { attrs: { for: el[_vm.displayField] } },
                                  [_vm._v(_vm._s(el[_vm.displayField]))]
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "confirmation-dialog-button-container" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "confirmation-modal-button",
                        on: { click: _vm.onConfirmClick }
                      },
                      [_vm._v(" " + _vm._s(_vm.positiveButtonText) + " ")]
                    ),
                    !_vm.hideCancel
                      ? _c(
                          "button",
                          {
                            staticClass: "confirmation-modal-button cancel",
                            on: { click: _vm.onCancelClick }
                          },
                          [_vm._v(" " + _vm._s(_vm.negativeButtonText) + " ")]
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            2
          ),
          _c("div", {
            class: _vm.hideCancel ? "confirmation-popup-backdrop" : "",
            on: {
              click: function($event) {
                !_vm.hideCancel ? _vm.closeDialog : () => {}
              }
            }
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }